import React, { useState, useEffect } from "react";
import "./PuttingSplits.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import PuttingSplitsTable from "./PuttingSplitsTable";
import Select from "react-select";
import DraftkingsInfoOverlay from "../../../../../DraftKingsInfoOverlay";

const QUERY = graphql`
  query PuttingSplitsQuery($eventID: ID!) {
    whoAmI {
      username
    }

    grassCategories {
      id
      categoryName
    }

    pgaTourEvent(eventId: $eventID) {
      tournament {
        officialName
      }
    }

    pgaEventCoursesForEvent(eventId: $eventID) {
      id

      course {
        name
      }

      primaryGreenGrass {
        id
        category {
          id
          categoryName
        }
      }
    }
  }
`;

export default function PuttingSplits({ eventId }) {
  const data = useLazyLoadQuery(QUERY, { eventID: eventId });

  const [selectedGrassCategoryID, setSelectedGrassCategoryID] = useState(
    undefined
  );

  const [grassCategorySelectValue, setGrassCategorySelectValue] = useState(
    undefined
  );

  function updateSelectedCategoryId(selected) {
    console.log(selected);

    setGrassCategorySelectValue(selected);
    setSelectedGrassCategoryID(selected.value);
  }

  if (!eventId) {
    return;
  }

  const eventCourses = data.pgaEventCoursesForEvent;

  useEffect(() => {
    if (eventCourses.length > 0) {
      const grass = eventCourses[0].primaryGreenGrass;

      if (!grass) {
        return;
      }

      updateSelectedCategoryId({
        value: grass.category.id,
        label: grass.category.categoryName,
      });
    }
  }, [eventId]);

  return (
    <div style={{ width: "100%", padding: "10px" }}>
      <div>
        <h3>Course Info for {data.pgaTourEvent.tournament.officialName}</h3>
        {data.pgaEventCoursesForEvent.map((eventCourse) => {
          let grassName = eventCourse.primaryGreenGrass?.category?.categoryName;

          if (!grassName) {
            grassName = "UNKNOWN";
          }

          return (
            <p key={eventCourse.id}>
              {eventCourse.course.name} greens have <strong>{grassName}</strong>{" "}
              grass
            </p>
          );
        })}
        <p>
          Below output includes up to <strong>36 most recent rounds</strong>{" "}
          each player in field has played
          {grassCategorySelectValue
            ? ` on ${grassCategorySelectValue.label} grass.`
            : "."}
        </p>
        <hr />
      </div>

      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>
        Green Grass Types
        <Select
          id="event"
          className="putting-splits-grass-select"
          options={data.grassCategories.map((cat) => {
            return { value: cat.id, label: cat.categoryName };
          })}
          onChange={updateSelectedCategoryId}
          style={{ zIndex: 5 }}
          value={grassCategorySelectValue}
        />
      </label>
      <React.Suspense fallback="Loading putting splits...">
        <PuttingSplitsTable
          eventId={eventId}
          grassCategoryId={selectedGrassCategoryID}
        />
      </React.Suspense>
    </div>
  );
}
